import { profile } from "../data/portfolio";
import ParticlePortrait from "./ParticlePortrait";

export default function Hero() {
  return (
    <section className="hero" id="top" aria-labelledby="hero-title">
      <div className="hero__portrait" aria-hidden="true">
        <ParticlePortrait />
      </div>

      <div className="hero__index" aria-hidden="true">
        <span>00</span>
        <span>/</span>
        <span>03</span>
      </div>

      <div className="hero__inner">
        <p className="hero__eyebrow">{profile.role}</p>

        <h1 className="hero__title" id="hero-title" aria-label={profile.name} >
          <span className="hero__title-line" >
            <span>Erik</span>
          </span>
          <span className="hero__title-line hero__title-line--offset">
            <span>Schmidt</span>
          </span>
        </h1>

        <div className="hero__details">
          <div className="hero__statement">
            <p>{profile.statement}</p>
            <p>{profile.stack}</p>
          </div>
          <p className="hero__location">
            <span className="status-dot" aria-hidden="true" />
            {profile.location}
          </p>
        </div>
      </div>

      <a className="scroll-cue" href="#about" aria-label="Scroll to about">
        <span>Scroll</span>
        <span className="scroll-cue__line" aria-hidden="true" />
      </a>
    </section>
  );
}
